import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../Common/TextInput';
import { useAccounts } from '../../DataStore/AccountsContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { useSchool } from '../../DataStore/SchoolContext';
import CallOut from '../Common/CallOut';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    voteName: '',
    cashAccount: '',
    incomeAccount: '',
    loading: false,
}


const AssignFeesVote = ({feesGroup}) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const {setSystemFunction} = useTheme();
    const {getFeesVotes, feesVoteListing, getFeesGroups, getFeesStructures} = useSchool();
    const [vote, setVote] = useState('');
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);


    
    useEffect(()=>{
        setSystemFunction(() => handleSave);
        return () => setSystemFunction(() => {});
    }, [vote, amount]);


    const handleSave=async()=>{
        setInfo('');
        if(!vote.value){
            setInfo(<Notification type="danger" message="Select fees vote then try again." closable={false}/>)
            return;
        }
        setInfo('');
        setLoading(true);
        const server_response = await ajaxSchool.defineGroupStructure(feesGroup.group_info?.id, vote.value, amount);
        setLoading(false);
        if(server_response.status==="OK"){
            setAmount('');
            setInfo(<Notification type="success" message={server_response.message} closable={false}/>)
            await getFeesStructures(true);
        }else{
            setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)

    
        }
    }


    const RenderFeesVote = ()=>{
    
            const options=[];
            if(Array.isArray(feesVoteListing))
            {
                feesVoteListing.map((item, key)=>
                    options.push({label:item.vote_name, value:item.id})
                )
            }
    
            return(
                <TextInput
                type="select"
                label="Select Fees Vote"
                placeholder={vote.label || "Select fees vote..."}
                leftIcon="fa fa-tag"
                options={options}
                onChange={item => setVote(item)}
                leftComponent={<i className="fa fa-tag link" onClick={()=>getFeesVotes(true)}></i>}
                loading={!feesVoteListing}
                required
                wrap
                value={vote}
            />
    
            )
    
        }


    return (
        <>
        <CallOut
            title={`Group: ${feesGroup.group_info?.group_name}`}
            description="Populate the fees group with fees votes and specify the amount for billing."
            />

        <div className='mt-4'>{info}</div>
        <form method='post' onSubmit={handleSave}>
            {RenderFeesVote()}
            <TextInput
            type="number"
            label="Vote amount"
            placeholder="Enter vote amount"
            leftIcon="fa fa-credit-card"
            onChange={e => setAmount(e.target.value)}
            required
            value={amount}
            wrap
            />

        </form>
        </>
    );
};

export default AssignFeesVote;